import styled from "styled-components";
import { Divider as MUIDivider } from "@mui/material";
import { Link } from "react-router-dom";

export const NavigationWrapper = styled.aside`
  position: sticky;
  top: 0; /* Keeps it stuck to the top as you scroll */
  height: 100vh;
  overflow-y: auto; /* Allows the sidebar to scroll if content exceeds the viewport */
  background: linear-gradient(360deg, #440e69 13%, #221b3c 50.67%),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
  padding: 0 20px;

  & > header {
    /* display: grid;
    place-items: center; */
    padding: 0 10px;
  }
`;

export const NavigationWrapperPermissionView = styled.aside`
  position: sticky;
  top: 0; /* Keeps it stuck to the top as you scroll */
  height: 100vh;
  overflow-y: auto; /* Allows the sidebar to scroll if content exceeds the viewport */
  background: linear-gradient(360deg, #440e69 13%, #221b3c 50.67%),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
  /* padding: 0 20px; */

  & > header {
    /* display: grid;
    place-items: center; */
    padding: 0 10px;
  }
`;

export const Logo = styled.img`
  margin-top: 54px;
  /* cursor: ${({role}) => role === "admin" ? "pointer" : "default"}; */
  /* width: clamp(178px, 20%, 300px); */
  width: 100%;
  /* height: 36px; */
`;

export const Divider = styled(MUIDivider)`
  width: 100% !important;
  background: #e5f7ff !important;
  margin-top: 28px !important;
`;

export const MenuItemWrapper = styled(Link)`
  color: ${({ isSelected }) => (isSelected ? "#fff" : "#F2EFFD")};
  font-weight: ${({ isSelected }) => (isSelected ? "600" : "400")};
  text-decoration: none;
  font-family: "Montserrat";
  font-size: 18px;
  position: relative; 
  overflow: hidden;
  border-radius: 6px;
  background: ${({ isSelected }) => (isSelected ? "#ad9aff3b" : "transparent")};
  & > li {
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 17px;
    line-height: 18px;
  }
  & > *:hover {
    background: #ad9aff3b;
  }
  &::before {
    content: "";
    position: absolute;
    display: ${({ isSelected }) => (isSelected ? "block" : "none")};
    left: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: rgba(172, 138, 58, 1);
  }
  &:hover::before {
    display: block;
  }
`;

export const MenuList = styled.ul`
  list-style-type: none;
  margin: 48px 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
